import {inject} from '@angular/core';
import {ApolloClientOptions, ApolloLink, InMemoryCache} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import {setContext} from '@apollo/client/link/context';
import {ErrorLinkService} from '@shared/services/errorlink.service';
import {AuthHeaderService} from '@shared/services/auth-header.service';
import {environment} from '../../../environments/environment';


export const apolloClientFactory = (): Record<string, ApolloClientOptions<any>> => {
  const errorLinkService = inject(ErrorLinkService);
  const authHeaderService = inject(AuthHeaderService);
  const errorLink = errorLinkService.createErrorLink();

  function createHttpLinkWithOpName(baseUri: string): ApolloLink {
    const httpLink = inject(HttpLink);
    const opNameLink = new ApolloLink((operation, forward) => {
      operation.setContext({
        uri: `${baseUri}/${encodeURIComponent(operation.operationName || 'unknown')}`,
      });
      return forward(operation);
    });
    return ApolloLink.from([opNameLink, httpLink.create({uri: baseUri})]);
  }


  const authLink = setContext(async (_, {headers = {}, customHeaders = {}}) => {
    let updatedHeaders = {...headers};
    updatedHeaders = await authHeaderService.appendAuthToken(updatedHeaders, customHeaders);
    if (!updatedHeaders.Organisation) {
      updatedHeaders = await authHeaderService.appendCustomHeaders(updatedHeaders, customHeaders);
    }
    return {headers: updatedHeaders};
  });


  return {
    default: {
      link: ApolloLink.from([authLink, errorLink, createHttpLinkWithOpName(environment.TMP_GRAPHQL_BASE)]),
      cache: new InMemoryCache(),
      defaultOptions: {
        query: {
          fetchPolicy: 'network-only', // Default behavior for query
          errorPolicy: 'all',
        },
        mutate: {
          fetchPolicy: 'network-only', // Default behavior for mutate
          errorPolicy: 'all',
        }
      },
    },
    mesh: {
      link: ApolloLink.from([authLink, errorLink, createHttpLinkWithOpName(environment.MESH_GRAPHQL_BASE)]),
      cache: new InMemoryCache(),
      defaultOptions: {
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
        mutate: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        }
      }
    }
  };
};
